import { createMapper } from "../../../../../../../utils/utils";
import {
  PrescriptionFormPreferredDeliveryEnum,
  PrescriptionFormPrescriptionFormTypeEnum,
  PrescriptionFormProviderStatusEnum,
  PrescriptionFormSubstitutionsOrDispenseEnum,
  PrescriptionFormUnitEnum,
} from "./../../../../../../../services/api";

type SelectValue = { value: string; label: string };

export interface PrescriptionForm {
  substitutionsOrDispense?: PrescriptionFormSubstitutionsOrDispenseEnum;
  prescriptionFormType?: PrescriptionFormPrescriptionFormTypeEnum;
  medicationId?: SelectValue;
  // facility?: PrescriptionFormFacilityEnum;
  preferredDelivery: PrescriptionFormPreferredDeliveryEnum;
  prescriptionDate?: string;
  provider?: SelectValue;
  location?: SelectValue;
  patient?: { [key: string]: string };
  directionToPatient?: string;
  duration?: string;
  quantity?: string;
  unit?: PrescriptionFormUnitEnum;
  refills?: string;
  startDate?: string;
  endDate?: string;
  preferences?: SelectValue;
  notFillBefore?: string;
  priorAuthorization?: string;
  directionToPharmacist?: string;
  medicalCodes?: SelectValue[];
  active?: boolean;
  archive?: boolean;
  appointmentId?: string;
  providerStatus?: PrescriptionFormProviderStatusEnum;
}


export const TYPE_OPTIONS = [
  { value: "NEW_RX", label: "New Rx" },
  { value: "CHANGE_RX", label: "Change Rx" },
  { value: "REFILE", label: "Refill" },
];



 
export const SUBSTITUTIONS_OR_DISPENSE_OPTIONS_LABELS = [
  { label: "Substitutions Permitted", value: "SUBSTITUTIONS_PERMITTED" },
  { label: "Dispense As Written", value: "DISPENSE_AS_WRITTEN" },
];
export const SUBSTITUTIONS_OR_DISPENSE_OPTIONS =  createMapper(SUBSTITUTIONS_OR_DISPENSE_OPTIONS_LABELS);
